export const Enter = 'Enter'